import axios from 'axios'
import requester from '@ibkr/web.app.request.util';

export const api = axios.create({
    timeout: 15000,
    withCredentials: true
});

const handleResponse = (res, resolve, reject) => {
    (res.status == 200) ? resolve(res.data) : reject(res.statusText);
}

const buildPromise = (method, endPoint, data, config) => {
    return new Promise((resolve, reject) => {
        method(endPoint, data, config)
            .then(res => handleResponse(res, resolve, reject))
            .catch(reason => reject(reason));
    });
}

export function apiGet(endPoint, config) {
    return new Promise((resolve, reject) => {
        api.get(endPoint, config)
            .then(res => handleResponse(res, resolve, reject))
            .catch(reason => reject(reason));
    });
}

export function apiPost(endPoint, data) {
    return buildPromise(api.post, endPoint, data);
}

// requester is used to make requests to tws.proxy
export function apiTws(endPoint, headers = {}) {
    return new Promise((resolve, reject) => {
        requester.request(endPoint, headers)
            .then(res => resolve(res))
            .catch(reason => reject(reason));
    });
}